import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ExpandLess, ExpandMore, UnfoldMore } from "@mui/icons-material";
import { Box } from "@mui/material";
import { SxProps } from "@mui/system";
import type { ReactNode } from "react";

import { PMTableSortDirection } from "../../types/pm-table";
import { PMTableCell } from "./pm-table";

export const PMDraggableTableCell = ({
  fieldName,
  sx,
  label,
  allowColumnReorder = false,
  isSortable,
  sortDirection,
  onMouseEnter,
  onMouseLeave,
  onClick,
  actions,
}: {
  fieldName: string;
  sx: SxProps | undefined;
  label: string;
  allowColumnReorder?: boolean;
  isSortable?: boolean;
  sortDirection: PMTableSortDirection | null;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick: () => void;
  actions?: ReactNode;
}) => {
  const { attributes, isDragging, listeners, setNodeRef, transform } =
    useSortable({
      id: fieldName,
      resizeObserverConfig: {
        disabled: true,
      },
    });

  return (
    <PMTableCell
      ref={setNodeRef}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        opacity: isDragging ? 0.8 : 1,
        position: "relative",
        overflow: "visible",
        transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
        transition: "width transform 0.2s ease-in-out",
        whiteSpace: "nowrap",
        zIndex: isDragging ? 1 : 0,
        ...sx,
      }}
      {...(allowColumnReorder ? listeners : {})}
      {...(allowColumnReorder ? attributes : {})}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          overflow: "visible",
          gap: 0.5,
        }}
      >
        {label}

        {actions}

        {isSortable &&
          (sortDirection ? (
            sortDirection === "ASC" ? (
              <ExpandLess
                sx={{
                  fontSize: "1rem",
                }}
              />
            ) : (
              <ExpandMore
                sx={{
                  fontSize: "1rem",
                }}
              />
            )
          ) : (
            <UnfoldMore
              sx={{
                fontSize: "1rem",
              }}
            />
          ))}
      </Box>
    </PMTableCell>
  );
};
